var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNearusdt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "near",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400.7,25.8L296.3,180.6c-7.2,10.5,6.7,23.3,16.6,14.4l102.7-89.3c2.8-2.2,6.7-0.6,6.7,3.3v279.1c0,3.9-5,5.5-7.2,2.8 L104.3,19.1C94.3,6.9,79.9,0.3,63.8,0.3H52.7C23.9,0.3,0,24.1,0,53.6v392.9c0,29.4,23.9,53.3,53.3,53.3c18.3,0,35.5-9.4,45.5-25.5 l104.3-154.8c7.2-10.5-6.7-23.3-16.6-14.4L83.8,393.7c-2.8,2.2-6.7,0.6-6.7-3.3V111.8c0-3.9,5-5.5,7.2-2.8l310.8,371.8 c10,12.2,25,18.9,40.5,18.9h11.1c29.4,0,53.3-23.9,53.3-53.3V53.6c0-29.4-23.9-53.3-53.3-53.3C427.9,0.3,410.7,9.7,400.7,25.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearusdt);
export default __webpack_public_path__ + "static/media/nearusdt.a2317aae311c853ebe2828bce5b08490.svg";
export { ForwardRef as ReactComponent };